export default "__VITE_PUBLIC_ASSET__acd96fe4__"